var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0.5H13V15.5H1V0.5ZM2.4 1.9V14.1H11.6V1.9H2.4Z",
    fill: "#D26985"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 4.2H10.2V5.4H3.8V4.2Z",
    fill: "#D26985"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 6.9H10.2V8.1H3.8V6.9Z",
    fill: "#D26985"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 9.6H7.6V10.8H3.8V9.6Z",
    fill: "#D26985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.19aca5481b3d224c6d834b6055b7269f.svg";
export { ForwardRef as ReactComponent };